/*eslint-disable */
const $ = window.jQuery = require('jquery');  
export default {
  name: 'appFooter',
  components: {
  },
  props: [],
  data () {
    return {
      year: new Date().getFullYear()
    }
  },
  computed: {

  },
  mounted () {
		$(document).ready(function (argument) {
			$(".ab_btn").click( function(){
        $(window).scrollTop(0);
        $(".lymphomap_main").addClass("popup_actv");
        $(".welcome_popup_wrp").toggleClass("active");  
			});
    });
  },
  methods: {
  }
}
